const map = {
	"./878822c5-e6a3-4f59-bd94-ac5f57133576_removalai_preview.png": 8708,
	"./batch2.jpeg": 8918,
	"./bootcamp.jpeg": 5793,
	"./career-bg.jpg": 7433,
	"./confidential-bg.jpg": 9293,
	"./counseling-bg.jpg": 2514,
	"./courses-bg.jpg": 4737,
	"./empowering.jpg": 708,
	"./founder_pic.jpeg": 1672,
	"./holistic-bg.jpg": 2746,
	"./internships-bg.jpg": 4460,
	"./logo.jpeg": 9599,
	"./logo.png": 678,
	"./logo1.png": 5869,
	"./meditation-bg.jpg": 4571,
	"./personalized-bg.jpg": 6849,
	"./pratidhi_logo.jpeg": 745,
	"./professional-bg.jpg": 1812,
	"./profile.jpeg": 8921,
	"./psychometrics-bg.jpg": 8562,
	"./summerinternship.jpeg": 3255
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4348;